import termsAndPolicy from "./termsAndPolicy";
import contentSite from "./contentSite";

export default {
	action: {
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		create_account: 'Criar Conta',
		create_your_resume: 'Crie seu Currículo',
		create_free_account: 'Criar Conta FREE',
		create_new_process: 'Criar novo processo',
		created: 'Registado',
		close: 'Fechar',
		close_process: 'Fechar processo',
		delete: 'Excluir',
		disable: 'Desabilitar',
		end: 'Terminar',
		edit: 'Editar',
		ready_more: 'Leia Mais',
		register: 'Registar',
		remove: 'Remover',
		remember: 'Lembrar',
		reload: 'Recarregar',
		start: 'Começar',
		show: 'Exibir',
		send: 'Enviar',
	},
	login: {
		label: 'Login',
	},
	candidate: 'Candidato | Candidatos',
	closed_process: 'Processo Fechado | Processos Fechados',
	closed: 'Fechado | Fechados',
	created_by: 'Criado por',
	created_date: 'Data de criação',
	cv: 'Currículo | Currículos',
	curriculum_vitae: 'Curriculum Vitae | Curriculum Vitae',
	color: 'Cor | Cors',
	custom_features: 'Recurso sob medida | Recursos sob medida',
	curriculum: 'Curriculum | curriculums',
	compare_profile: {
		label: 'Compare Perfis',
		desc: 'Defina os critérios de avaliação dos perfis e compare os resultados.',
		ai: {
			title: 'IA',
			desc: 'Use o poder <strong>inteligência artificial</strong> para obter análises de avaliações de perfis conforme critérios específicos e editáveis, seja em processos seletivos de candidatos, cotações de fornecedores ou qualquer outro tipo de processo que desejar.',
			desc_hiring: 'Use o poder da <strong>inteligência artificial</strong> para obter análise das avaliações dos candidatos.'
		}
	},
	company: 'Empresa | Empresas',
	company_name: 'Nome da Empresa | Nome das Empresas ',
	city: 'Cidade | Cidades',
	current: 'Atual | Atuais',
	custom_label: 'Personalizado | Personalizados',
	confirmed: 'Confirmado | Confirmado',
	canceled: 'Cancelado',
	currency: {
		label: 'Moeda | Moedas',
		euro: 'Euro | Euros',
		dollar: 'Dolar| Dolars',
		pound: 'Pound | Pounds',
		real: 'Real | Reais'
	},
	content: 'Conteúdo | Conteúdos',
	n_user: '{n} Utilizador | {n} Utilizadores',
	no_content: 'Sem conteúdo | Sem conteúdo',
	closing_date: 'Data de Fechamento| Datas de Fechamento',
	closed_data: 'Data de Fechamento| Datas de Fechamento',
	closed_with_delay: 'Fechado com Atraso',
	closed_with_delay_explanation: 'Processo fechado após o prazo',
	closed_in_time: 'Fechado em Tempo',
	closed_in_time_explanation: 'Processo fechado antes do prazo',
	contact: {
		label: 'Contacto | Contactos',
		request_contact: 'Pedir Contato',
		send_your_msn: 'Mande sua mensagem',
		any_questions: `Alguma questão ou dúvida?
						Mande agora uma mensagem.`,
		suporte_contact: 'Contacto de suporte',
		if_prefer_send_email: `Se preferir, envies um e-mail para nosso suporte`,
		menssage_sent: 'Mensagem enviada',
		we_will_response_soon: 'Responderemos em breve.',
	},

	done: 'Finalizado | Finalizados',
	delete_account: {
		label: 'Excluir Conta e Perfil',
		text: `Para excluir sua conta e perfil, envie uma mensagem
            para <b>{email}</b> com sua solicitação.`
	},
	disabled: 'Desablitado | Desablitados',
	description: 'Descrição | Descrições',
	deleted: 'Excluído | Excluídos',
	default: 'Padrão | Padrões',
	default_label: 'Rótulo Padrão| Rótulos Padrão',
	derived_process: 'Processo Derivado | Processos Derivados',
	discount: 'Desconto | Descontos',
	down: 'Baixo',
	developed_projects: 'Projeto Desenvolvido | Projetos Desenvolvidos',
	dashboard: 'Painel de Controle',
	deadline: 'Prazo | Prazos',
	data: 'Data | Datas',
	email: 'E-mail | E-mails',
	education: 'Educação | Educação',
	expense: 'Despesa | Despesas',
	end: 'Fim | Finais',
	end_date: 'Data Fim | Datas Fim',
	error: {
		label: 'Erro',
		file_too_big: 'Tamanho máximo permitido de 1mb',
		sending_data: 'Erro ao enviar os dados',
		generic: 'Ocorreu um erro. Cod. {code}',
		item_is_required: '{item}: É necessário.',
		comment_something: 'Comment Algo',
		user_not_confirmed_email_sent: `Email não confirmado. Uma mensagem de
      confirmação foi enviada novamente. Por favor, acesse o link na mensagem.`
	},
	profile_bank: 'Banco de Currículos | Bancos de Currículos ',
	from: 'De',
	free_support_and_training: 'Suporte e treinamento sem custo',
	file_attachment: 'Anexar Arquivo',
	feature: 'Recurso | Recursos',
	fixed_cost: 'Custo Fixo | Custos Fixos',
	first_name: 'Primeiro Nome | Primeiros Nomes',
	flow: 'Fluxo | Fluxos',
	flow_process: 'Fluxo de Processo | Fluxos de Processos',
	file: 'Arquivo | Arquivos',
	field: 'Campo | Campos',
	filter: 'Filtro | Filtros',
	filter_by_user: 'Filtrar por utilizador | Filtrar por utilizadores ',
	gender: 'Gênero | Gêneros',
	general_registation: 'Registo Geral | Registos Gerais',
	home: 'Home | Homes',
	height: 'Altura | Alturas',
	help_center: 'Central de Ajuda | Centrais de Ajuda',
	input: 'Campo | Campos',
	in_progress: 'Em Andamento',
	id: 'Id | Ids',
	item: 'Item | Itens',
	interview: 'Intrevista | Intrevistas',
	income: 'Receita | Receitas',
	logout: 'Log Out',
	logo: 'Logo | Logos',
	link: 'Link | Links',
	link_to_register_form: 'Link para o formulário de cadastro | Links para os formulários de cadastro',
	link_to_register: 'Link para registar perfil| Links para registar perfis',
	linked_user: 'Utilizador | Utilizadores',
	linked_user_status: 'Utilizadores  associados e status | Utilizador associado e status',
	last_update: 'Última Atualização | Últimas Atualizações',
	linked_process: 'Processo Associado | Processos Associados',
	lebel: 'Rótulo | Rótulos',
	level: 'Nível | Níveis',
	list: 'Lista | Listas',
	language: {
		label: 'Língua | Línguas',
		portuguese: 'Português',
		portuguese_br: 'Português BR',
		english: 'Inglês',
		english_us: 'Inglês',
		spanish: 'Espanhol'
	},
	free_period: '1 Mês Grátis',
	main: 'Principal | Principais',
	model: 'Modelo | Modelos',
	menu: 'Menu | Menus',
	min: 'Min | Min',
	max: 'Max | Max',
	main_user: 'Utilizador Principal | Utilizadores  Principais',
	main_process: 'Processo Principal | Processos Principais',
	main_profiles: 'Perfil Principal | Perfis Principais',
	media: 'Mídia | Mídias',
	my_company: 'Minha Empresa | Minhas Empresas',
	my_account: 'Minha conta | Minhas contas',
	min_stock: 'Min Estoque | Min Estoques',
	max_stock: 'Max Estoque | Max Estoques',
	my_user: 'Meu Utilizador | Meus Utilizadores ',
	my_profile: 'Meu Perfil | Meus Perfis',
	method: 'Metodo | Metodos',
	month: 'Mês | Meses',
	module: 'Módulo | Módulos',
	municipal_code: 'Código Municipal | Códigos Municipais',
	name: 'Nome | Nomes',
	not_archived: 'Não Arquivado | Não Arquivados',
	not_confirmed: 'Não Confirmado | Não Confirmado',
	not_rated: 'Não Avaliado | Não Avaliados',
	not_selected: 'Não Selecionado | Não Selecionados',
	name_singular: 'Nome Singular| Nomes Singular',
	name_plural: 'Nome Plural| Nomes Plural',
	new_product: 'Novo Produto | Novos Produtos',
	new: 'Novo | Novos',
	new_type: 'Novo Tipo| Novos Tipos',
	number: 'Número | Números',
	next: 'Próximo | Próximos',
	new_reating: 'Nova Avaliação | Novas Avaliações',
	no_status_registered: 'Sem Status Registado | Sem Status Registados',
	only_open_task: 'Apenas tarefas em aberto | Apenas tarefas em aberto',
	official_identification: 'Identificação Oficial | Identificações Oficiais',
	observation: 'Observação | Observações',
	ok: 'Ok',
	online_system: 'Sistema Online | Sistemas Online',
	operating_area: {
		label: 'Área de Atuação',
		culture: 'Cultura',
		human_resources: 'Recursos Humanos',
		provide_services: 'Provedor de Serviços',
		product_sales: 'Venda de Produtos',
		products_and_services: 'Produtos e Serviços',
		financial: 'Financeiro',
		education: 'Educação',
		ti: 'TI',
		marketing: 'Marketing',
		health: 'Saúde',
		others: 'Outros',
	},
	opened: 'Em Aberto | Em Aberto',
	open_task: 'Tarefa em Aberto | Tarefas em Aberto',
	overview: 'Visão Geral | Visões Gerais',
	origin_process: 'Processo de Origem | Processos de Origem',
	per_user_per_month: 'por utilizador por mês',
	pending: 'Pendente',
	process: 'Processo | Processos',
	process_and_profile_configurator: 'Configurador de processos e perfis',
	process_settings: 'Configuração do Processo | Configurações dos Processos',
	process_permissions: 'Permissição do Processo | Permissões do Processo',
	process_management: 'Gestão de Processos',
	perishable: 'Perecível | Perecíveis',
	process_module: {
		label: 'Módulo do Processo| Módulos do Processo',
		process: 'Processo | Processos',
		message: {}
	},
	process_id: 'ID Processo | IDs Processos',
	process_type: 'Tipo de Processo | Tipos de Processos',
	process_resume: 'Resumo do Processo | Resumo dos Processos',
	profile: 'Perfil | Perfis',
	profile_status: {
		label: 'Status do Perfil | Status dos Perfis',
		desc: 'Acompanhe e atualize facilmente o status de todos os perfis que participam de um processo.'
	},
	profile_and_curriculum: 'Perfil & Currículo| Perfis & Currículos',
	profile_group: 'Grupo de Perfil | Groups de Perfil',
	profile_removed: 'Perfil Removido | Perfis Removidos',
	profile_settings: 'Configuração do Perfil | Configurações dos Perfis',
	profile_permissions: 'Permissão do Perfil | Permissões do Perfil',
	profile_n: '{n} Perfil | {n} Perfis',
	profile_type: 'Tipo de Perfil | Tipos de Perfis',
	profile_user: 'Utilizador do Perfil | Utilizadores dos Perfis',
	product: 'Produto | Produtos',
	product_destination: 'Destinatário do Produto | Destinatários do Produtos',
	product_origin: 'Origem do Produto | Origens dos Produto',
	product_updated: 'Produto Atualizado | Produtos Atualizados',
	product_registered: 'Produto Registado| Produtos Produtos',
	project: 'Projeto | Projetos',
	position: 'Posição | Posições',
	previous: 'Anterior | Anteriores',
	password: 'Palavra-Passe | Palavras-Passe',
	password_repeat: 'Repetir Palavra-Passe | Repetir Palavras-Passe',
	payment: 'Pagamento | Pagamentos',
	point: 'Ponto | Pontos',
	profile_id: 'ID do Perfil | IDs dos Perfis',
	professional_identification: 'Identificação Profissional | Identificações Profissionais',
	plan: {
		label: 'Plano | Planos',
		for_custom: 'Para planos personalizados, contactar {email}',
		use_your_domain: {
			label: 'Seu Domínio',
			text: 'Será usado o seu domínio para acessar a sua conta.'
		},
		use_your_email: {
			label: 'Seu e-mail',
			text: 'Poderá usar o e-mail corporativo quando o sistema enviar mensagens da sua conta.'
		},
		your_logo: {
			label: 'Sua Logo',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_theme: {
			label: 'Suas cores e temas',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_features: {
			label: 'Recursos Personalizados',
			text: 'Use your corporate email address when the system sends messages from your account.'
		}
	},
	quotation: 'Cotação | Cotação',
	quotation_and_purchase: 'Cotação/Compras',
	ranking: 'Ranking | Rankings',
	resend_confimation_email: 'Reenviar email de confirmação.',
	result: 'Resultado | Resultados',
	registered_reating: 'Avaliação Registada | Avaliações Registadas',
	ratings: 'Avaliação | Avaliações',
	registered_date: 'Data de Registo | Datas de Registo',
	rating_submitted: 'Avaliação Submetida | Avaliações Submetidas',
	rating_deleted: 'Avaliação Deletada | Avaliações Deletadas',
	required: 'Obrigatório | Obrigatórios',
	recent_activity: 'Atividade Recente | Atividades Recentes',
	responsible: 'Responsável | Responsáveis',
	responsible_user: 'Usário responsável | Usários responsáveis',
	raking_position: 'Posição no Raking | Posições no Raking',
	raking: 'Raking | Rakings',
	rating_record: 'Registo de Avaliação | Registos de Avaliações',
	requirement: 'Requisito | Requisitos',
	role: 'Papel | Papeis',
	saved: 'Salvo | Salvo',
	recruitment: 'Recrutamento | Recrutamento',
	referral: {
		label: 'Referência | Referências',
		have: 'Possui referência | Possui referências',
		label_email: 'E-mail de Referência | E-mail de Referências',
		text_register: 'E-mail da pessoa que lhe apresentou o sistema'
	},
	resume: 'Resumo | Resumos',
	record: 'Registo | Registos',
	rating: 'Avaliação | Avaliações',
	subject: 'Assunto | Assunto',
	setting: 'Configuração | Configurações',
	stock_control: 'Controle de Estoque | Contole de Estoques',
	state_code: 'Código do Estado | Códigos do Estado',
	selected: 'Selecionado | Selecionados',
	start: 'Começo | Começos',
	started: 'Iniciado | Iniciados',
	start_date: 'Data Início | Datas Início',
	storage: 'Armazenamento | Armazenamentos',
	shipping: 'Entrega | Entregas',
	specialization: 'Especialização | Especializações',
	summary: 'Apresentação | Apresentações',
	start_page: "Página Inicial",
	serial_number: 'Serial Number | Serial Numbers',
	selective_process: 'Processo Seletivo | Processo Seletivo',
	skill: 'Skill | Skills',
	stock: 'Estoque | Estoques',
	service: 'Serviço | Serviços',
	selection_data: 'Dado Selecionado | Dados Selecionados',
	status: 'Status | Status',
	status_detail: 'Detalhe do Status| Detalhe do Status',
	to: 'Para',
	to_sale: 'Para Venda | Para Vendas',
	tag: 'Tag | Tag',
	title: 'Título | Títulos',
	street: 'Rua | Ruas',
	weight: 'Peso | Pesos',
	task: 'Tarefa | Tarefas',
	team_management: 'Gestão de Equipas',
	term: 'Termo | Termos',
	type: 'Tipo | Tipos',
	time: 'Hora | Horas',
	technology: 'Tecnologia | Tecnologias',
	total: 'Total | Totais',
	url: 'Url | Urls',
	unlimited: 'Ilimitado | Ilimitados',
	updated: 'Atualizado | Atualizados',
	user: {
		label: 'Utilizador | Utilizadores ',
		select: 'Selcione utilizador | Selcione utilizadores '
	},
	value: 'Valor | Valores',
	your_message: 'Sua Mensagem | Suas Mensagens',
	warning: 'Aviso | Avisos',
	kanban: 'Card | Cards',
	terms_of_use: 'Termos de Uso',
	site: contentSite,
	...termsAndPolicy,
}
